import { useCallback, useState } from "react"
import { calculateAge } from "source/registrations/utils/dates"

/**
 * Custom hook for age validation in birthday fields
 * @param {boolean} isBirthdayField - Whether this field should validate age
 * @param {string} personName - Name of the person for the warning message
 * @returns {Object} { ageWarning: string, checkAge: function }
 */

export const useAgeCheck = (isBirthdayField, personName) => {
  const [ageInfo, setAgeInfo] = useState("")

  const checkAge = useCallback(
    (date) => {
      if (!isBirthdayField || !date) return setAgeInfo("")

      if (date.match(/^\d{2}\/\d{2}$/)) {
        const currentYear = new Date().getFullYear()
        date = `${date}/${currentYear}`
      }

      let age = calculateAge(date, new Date())
      let timeUnits = "year"

      if (Math.abs(age) < 1) {
        age = calculateAge(date, new Date(), false)
        timeUnits = "month"
      }

      if (Math.abs(age) > 1) {
        timeUnits += "s"
      }

      const ageText = `${age} ${timeUnits} old`

      const infoMessage = `${personName || "This person"} is ${ageText}`
      setAgeInfo(infoMessage)
    },
    [isBirthdayField, personName],
  )

  return { ageInfo, checkAge }
}
